import React, { useState } from "react";
import Loader from "../Shared/Loader";
import { FiImage } from "react-icons/fi";
import { uploadeImage } from "../../api/uploadImage";
import { AiOutlinePlus } from "react-icons/ai";

const PostForm = () => {
  const [loading, setLoading] = useState(false);
  const [images, setImages] = useState([]);
  const [count, setCount] = useState(1);
  const [featureValues, setFeatureValues] = useState({});

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const form = e.target;
    const title = form.title.value;
    const technologics = form.tech.value
    const subTitle = form.subtitle.value;
    const live_link = form.live.value;
    const client_link = form.client.value;
    const server_link = form.server.value;
    const details = form.details.value;

    const features = [...Object.values(featureValues)];

    const promise = Array.from(images).map((item) =>
      uploadeImage(item).then((img) => img.url)
    );

    Promise.all(promise).then((gallery) => {
      console.log(gallery);
      let post = {};
      if (server_link === "") {
        post = {
          title,
          subTitle,
          details,
          features:features,
          technologics,
          live_link,
          client_link,
          gallery:gallery
        }
      } else {
        post = {
          title,
          subTitle,
          details,
          features:features,
          live_link,
          technologics,
          client_link,
          server_link,
          gallery:gallery
        }
      }
      fetch(`https://portfolio-server-ten-theta.vercel.app/project`,{
        method: "post",
        headers: {
          "content-type":"application/json",
        },
        body:JSON.stringify(post),
      })
      .then(res=>res.json())
      .then(data=>{

        console.log(data)
        setLoading(false);

      })
    });
  };

  const handleFeature = (input, i) => {
    const abc = {};
    abc[input.name] = input.value;
    setFeatureValues({ ...featureValues, ...abc });
  };

  return (
    <form className="w-full space-y-8" onSubmit={handleSubmit}>
      <div className="w-full pb-5 space-y-2 md:space-y-0 md:flex items-center justify-between gap-5">
        <div className="md:w-1/2  text-slate-200 ">
          <input
            type="text"
            name="title"
            className="bg-transparent py-3 w-full focus:outline-none"
            placeholder="project name..."
          />
          <div className=" h-[1px] bg-gradient-to-r from-yellow-400 to-gray-700 " />
        </div>
        <div className="md:w-1/2  text-slate-200 ">
          <input
            type="text"
            name="subtitle"
            className="bg-transparent py-3 w-full focus:outline-none"
            placeholder="subtitle..."
          />
          <div className=" h-[1px] bg-gradient-to-r from-yellow-400 to-gray-700 " />
        </div>
      </div>
      <div>
        {[...Array(count)].map((_, i) => (
          <div key={i} className="  text-slate-200 mt-2 md:w-1/2">
            <div className="flex items-end">
              <input
                type="text"
                name={i}
                onChange={(e) => handleFeature(e.target, i)}
                className="bg-transparent py-2 w-full focus:outline-none flex-1"
                placeholder="add features..."
              />
              {i === [...Array(count)].length - 1 && (
                <div
                  className="text-right p-1 hover:cursor-pointer border border-yellow-400"
                  onClick={() => setCount(count + 1)}
                >
                  <AiOutlinePlus />
                </div>
              )}
            </div>
            <div className=" h-[1px] bg-gradient-to-r from-yellow-400 to-gray-700 " />
          </div>
        ))}
      </div>
      <div className="flex gap-3 items-center">
        <label className="bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 rounded inline-block hover:cursor-pointer relative p-[1px]">
          <input
            className="px-4 py-3 text-gray-800 border rounded w-0 h-0"
            type="file"
            multiple={true}
            name="image"
            onChange={(e) => setImages(e.target.files)}
          />
          <div className="absolute inset-0 m-[1px] bg-white p-2 text-slate-700 font-xl rounded">
            <FiImage className="text-xl" />
          </div>
        </label>
        {Array.from(images).length > 0 &&
          Array.from(images).map((item, i) => (
            <div key={i} className="flex items-center justify-center gap-3">
              <div className="mt-3 inline-block bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 p-[1px] rounded hover:cursor-pointer">
                <img
                  src={window.URL.createObjectURL(item)}
                  className="w-14 h-14 border border-white rounded"
                  alt=""
                />
              </div>
            </div>
          ))}
      </div>
      <div className="w-full pb-5 space-y-2 md:space-y-0 md:flex items-center justify-between gap-5">
        <div className="md:w-1/2 text-slate-200 ">
          <input
            type="text"
            name="live"
            className="bg-transparent py-3 w-full focus:outline-none"
            placeholder="live link..."
          />
          <div className=" h-[1px] bg-gradient-to-r from-yellow-400 to-gray-700 " />
        </div>
        <div className="md:w-1/2  text-slate-200 ">
          <input
            type="text"
            name="tech"
            className="bg-transparent py-3 w-full focus:outline-none"
            placeholder="technologices...."
          />
          <div className=" h-[1px] bg-gradient-to-r from-yellow-400 to-gray-700 " />
        </div>
      </div>

      <div className="w-full pb-5 space-y-2 md:space-y-0 md:flex items-center justify-between gap-5">
        <div className="md:w-1/2  text-slate-200 ">
          <input
            type="text"
            name="client"
            className="bg-transparent py-3 w-full focus:outline-none"
            placeholder="client side repository..."
          />
          <div className=" h-[1px] bg-gradient-to-r from-yellow-400 to-gray-700 " />
        </div>
        <div className="md:w-1/2  text-slate-200 ">
          <input
            type="text"
            name="server"
            className="bg-transparent py-3 w-full focus:outline-none"
            placeholder="sever site link..."
          />
          <div className=" h-[1px] bg-gradient-to-r from-yellow-400 to-gray-700 " />
        </div>
      </div>
      <div>
        <textarea
          name="details"
          id=""
          placeholder="details"
          cols=""
          rows="4"
          className="block rounded focus:green-300 w-full px-4 py-3 text-slate-200 bg-transparent focus:outline-none"
        ></textarea>
        <div className="h-[1px] bg-gradient-to-r from-yellow-400 to-gray-700 " />
      </div>
      <div className="pt-5 w-full text-end">
        <button
          type="submit"
          className="px-5 py-2 rounded  text-black bg-gradient-to-r from-yellow-400 to-yellow-200 shadow-lg   font-bold text-xs tracking-widest uppercase mx-auto"
        >
          {loading ? <Loader /> : "Post work "}
        </button>
      </div>
    </form>
  );
};

export default PostForm;
